module.exports = __webpack_public_path__ + "static/media/header_easybetbot.e23df583.png";